import React from 'react';

export const GameCoverInfo = ({ currentGamePrice, gamePassDataFound }) => {
  return(
    <>
      {currentGamePrice?.deals[0].cut > 0 && <div className="thirdPartyBanner" style={{backgroundImage:"linear-gradient(270deg, rgb(76, 107, 34), #0d1041",color:"rgb(190, 238, 17)",top:"-40px"}}>{currentGamePrice?.deals[0].cut}% off</div>}
      {gamePassDataFound?.type === "ea" && <div className="thirdPartyBanner" style={{backgroundImage:"linear-gradient(270deg, #e52a35, #0d1041"}}>On EA Play</div>}
      {gamePassDataFound?.type === "xbox" && <div className="thirdPartyBanner" style={{backgroundColor:"#0e7a0d"}}>On GamePass</div>}
    </>
  );
};

export default GameCoverInfo;